import { documentSetCookie } from '../cookie';
import { createSelector } from 'reselect';

export const USER_LOGIN = 'user/USER_LOGIN';
export const USER_STATE = 'user/USER_STATE';
export const USER_LOGOUT = 'user/USER_LOGOUT';
export const USER_DIDOMI_CONSENT_ACCEPTED = 'user/DIDOMI_CONSENT_ACCEPTED';
export const USER_SKIP_DIDOMI_CONSENT = 'user/SKIP_DIDOMI_CONSENT';
export const USER_SHOW_MOBILE_ITEM_IN_APP = 'user/USER_SHOW_MOBILE_ITEM_IN_APP';

/**
 * UNCHECKED - initial state when user info is unknown
 * PENDING - calling auth api in progress
 * CHECKED - auth api called and user info is actual
 * @type {{UNCHECKED: string, PENDING: string, CHECKED: string}}
 */
export const UserState = {
  UNCHECKED: 'unchecked',
  PENDING: 'pending',
  CHECKED: 'checked',
};

export const userInitialState = {
  username: '',
  isLoggedIn: false,
  isPremium: false,
  state: UserState.UNCHECKED,
  didomiConsentAccepted: null,
  skipDidomiConsent: false,
  showMobileItemInApp: '',
};

export const userLoginAction = payload => ({ type: USER_LOGIN, payload });
export const userStateAction = payload => ({ type: USER_STATE, payload });
export const userLogoutAction = () => ({ type: USER_LOGOUT });
export const userDidomiConsentAcceptedAction = payload => ({ type: USER_DIDOMI_CONSENT_ACCEPTED, payload });
export const userSkipDidomiConsentAction = payload => ({ type: USER_SKIP_DIDOMI_CONSENT, payload });
export const userShowMobileItemInAppAction = payload => ({ type: USER_SHOW_MOBILE_ITEM_IN_APP, payload });

export const changeUserShowMobileItemInAppPersistent = value => dispatch => {
  const setMaxTime = value === true ? 30 : 14;
  documentSetCookie('showMobileItemInApp', value, '/', (60 * 60 * 24 * setMaxTime));
  dispatch(userShowMobileItemInAppAction(value));
};

export const userReducer = (state = userInitialState, action) => {
  switch (action.type) {
  case USER_LOGIN:
    return {
      ...state,
      ...action.payload,
      state: UserState.CHECKED,
    };
  case USER_STATE:
    return {
      ...state,
      state: action.payload,
    };
  case USER_LOGOUT:
    return {
      ...state,
      username: '',
      isLoggedIn: false,
      isPremium: false,
      state: UserState.CHECKED,
    };
  case USER_DIDOMI_CONSENT_ACCEPTED:
    return {
      ...state,
      didomiConsentAccepted: action.payload,
    };
  case USER_SKIP_DIDOMI_CONSENT:
    return {
      ...state,
      skipDidomiConsent: action.payload,
    };
  case USER_SHOW_MOBILE_ITEM_IN_APP:
    return {
      ...state,
      showMobileItemInApp: action.payload,
    };  
  default:
    return state;
  }
};

export const selectUserState = ({ user }) => user.state;
export const selectIsLoggedIn = ({ user }) => user.isLoggedIn;
export const selectUsername = ({ user }) => user.username;
export const selectIsPremium = ({ user }) => user.isPremium;
export const selectDidomiConsentAccepted = ({ user }) => user.didomiConsentAccepted;
export const selectSkipDidomiConsent = ({ user }) => user.skipDidomiConsent;
export const selectShowMobileItemInApp = ({ user }) => user.showMobileItemInApp;
export const selectDidomiConsentAcceptedOrSkipped = createSelector(
  selectSkipDidomiConsent,
  selectDidomiConsentAccepted,
  (skip, accepted) => skip || accepted,
);
export const selectDidomiConsentCookieAccepted = createSelector(
  selectDidomiConsentAccepted,
  accepted => {
    return accepted && accepted.enabled.includes('cookies');
  },
);
export const selectDidomiConsentCookieAcceptedOrSkipped = createSelector(
  selectSkipDidomiConsent,
  selectDidomiConsentCookieAccepted,
  (skip, accepted) => skip || accepted,
);
export const selectDidomiConsentAdAccepted = createSelector(
  selectDidomiConsentAccepted,
  accepted => accepted && [
    'measure_ad_performance',
    'measure_content_performance',
    'market_research',
    'improve_products',
  ].every( x => accepted.enabled.includes(x)),
);
export const selectDidomiConsentSocialAccepted = createSelector(
  selectDidomiConsentAccepted,
  accepted => accepted && accepted.enabled.includes('social_media'),
);

